import { AuthorizationData } from '@kaseya-shared';

const actionScope = '[Totp MFA]';

export class VerifyTotpMfa {
  static readonly type = `${actionScope} Verify Totp Mfa`;
  constructor(public passCode: string) {}
}

export class VerifyTotpMfaCompleted {
  static readonly type = `${actionScope} Verify Totp Mfa Completed`;
  constructor(public authorizationData: AuthorizationData) {}
}

export class VerifyTotpMfaError {
  static readonly type = `${actionScope} Verify Totp Mfa Error`;
}

export class VerifyTotpMfaUserNotFoundError {
  static readonly type = `${actionScope} Verify Totp Mfa User Not Found Error`;
}

export class VerifyTotpMfaInvalidTotpCodeError {
  static readonly type = `${actionScope} Verify Totp Mfa Invalid Totp Code Error`;
}

export class VerifyTotpMfaUserLockedOutError {
  static readonly type = `${actionScope} Verify Totp Mfa User Locked Out Error`;
}

export class MfaTokenExpiredError {
  static readonly type = `${actionScope} Mfa Token Expired Error`;
}
